import { useContext } from 'react';
import { getLabel } from '../../../InitData';
import { formatDate, getCheckbetUrl, getConfiguration, getCurrencySymbol, getHiddenTicket, getPrintableAmount, getTicketStatusDescription } from '../../../data/utils';
import { TicketPrinterContext } from '../../printer/TicketPrinterConf';
import EventsList from '../EventsList';
import SocialShareButtons from '../SocialShareButtons';
import TupleInfo from '../TupleInfo';
import Winnings from '../Winnings';
import ReloadTicketSection from '../my-bets-layout-2/ReloadTicketSection';
import { getEnv } from '../../env';

function SystemBetsTicket(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
    const printerContext = useContext(TicketPrinterContext);

    const ticketUrl = getCheckbetUrl(props.ticket.id);
    const printTicketEnabled = conf.pto !== undefined? conf.pto : true;

    let descTicket = getLabel('mybets.sistema');
    let ticketStatus = null;
    if(props.infoTicket || conf.dtsch){
        descTicket = descTicket + " " + (props.ticket.psv? getLabel('retail.protocol.psv') : getLabel('retail.protocol.psqf'));
        ticketStatus = getTicketStatusDescription(props.ticket.status, props.ticket.paidWithCashout);
    }
    return (
        <div className="mybet-container d-flex flex-column">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle">
                <span className="text-big">{descTicket} ({props.ticket.events.length})</span>
                <span className="margin-auto">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.freebet')}</span>
                    }
                    {ticketStatus &&
                        <span className="cg-mybet-status-label">{ticketStatus.toUpperCase()}</span>
                    }
                </span>
            </div>
            <hr />
            <div className="mybet-events-container">
                <EventsList isPsv={props.ticket.psv} events={props.ticket.events} isSystem={true} />
            </div>
            <div className="light-grey-bg">
                <div className="bet-info d-flex justify-content-space-between align-items-center">
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.quotatotale')}</span><span className="text-medium bold">{getLabel('mybets.nondisponibile')}</span>
                    </div>
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.importo')}</span><span className="text-medium bold">{getPrintableAmount(props.ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                    <Winnings {...props.ticket} />
                </div>
                <hr />
                {!(window?.appConfig?.SHOP_MODE) &&
	                <div className="bet-info d-flex justify-content-space-between align-items-center">
			    		<div className="d-flex flex-column text-small var-disclaimer">
		    				<span className="bet-info-buttons-container justified-text text-medium bold">
                                {printTicketEnabled && 
                                    <div className="my-bets-printer" onClick={() => { printerContext.printTicket(props.ticket.id, false)}}>
                                        <img src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`} alt="Print button" />
                                    </div>
                                }
		    					<SocialShareButtons ticketUrl={ticketUrl} />
	                            <ReloadTicketSection isCheckbet={true} ticket={props.ticket} />
		    				</span>
			    		</div>
			    		 {/*
			    			<button onClick={() => { openCashout()}} className="bottone bet-info bg-arancio bianco maiuscolo">
	                        {getLabel('checkbet.button')}
	                        <span className="checkbetIconContainer">
	                        <i className="fa fa-caret-right"></i>
	                        </span>
			    			</button>	
	                    */}
		    		</div>
	    		}
                <hr />
                <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey pointer tuples-toggle">
                    <div className="d-flex justify-content-space-between">
                        <span>{getLabel('mybets.sistema')}</span>
                        &nbsp;
                    </div>
                    <div className="d-flex justify-content-space-between">
                        <span>Ref. {props.obfuscateTicketId?getHiddenTicket(props.ticket.id):props.ticket.id}</span>
                        <span className="margin-left-right">|</span>
                        <span>{formatDate(props.ticket.timestamp).formatted}</span>
                    </div>
                </div>
            </div>
            <div className="light-grey-bg">
                <TupleInfo tuples={props.ticket.tuples} ticketId={props.ticket.id} openCheckSystemBets={props.openCheckSystemBets} />
            </div>
        </div>
    );
}

export default SystemBetsTicket;